<div class="navbar-header">
    <a class="" rel="home" href="#" title="">
        <img class="responsive" style="width:100%;height: auto;"
             src="assets/images/header-1.jpg">
    </a>
</div>
<section id="header" class="rounded" style="margin-top:1%;background-color:white;text-align: center;text-emphasis-color: inherit"><strong>ISKCON Indore</strong>
    <div class="container">
        <div class="row" >
            <div class="col-md-12 col-xs-12 col-centered" style="align-items: center;
            text-decoration: underline;">
            <strong>Online Fee payment</strong></div>
        </div>
    </div>
</section>
<div class="card" style="margin-top: 1%">
<h4 class="card-header">Student Fee Details</h4>
<div class="card-body" *ngIf="((!isRecordNotFound))" >


    <form [formGroup]="form" (ngSubmit)="onSubmit()">

        <div class="studentDetailsDiv">

            <div class="form-group form-obj">
               <strong> <label for="mobileNo" style="">Name :</label></strong> {{studentData.studentName.charAt(0).toUpperCase()+studentData.studentName.slice(1)}}
            </div>


            <div class="form-group form-obj">
              <strong> <label for="type"> Type :</label></strong> {{studentData.residentType}}
            </div>

            <div class="form-group form-obj"style="float: left;" *ngIf="checkZero(studentData.roomNo)" >
                <strong> <label for="mobileNo"> Room No :</label></strong> {{studentData.roomNo}}
            </div>



          <div class="form-group form-obj" style="float: right;">
            <strong> <label for="mobileNo"> Due Date:</label></strong> {{dueDate}}
          </div>

            <div class="form-group form-obj" *ngIf="checkZero(feeData.lateFee)">
              <strong> <label for="mobileNo"> late Fees :</label></strong> {{feeData.lateFee}}
          </div>
          <div class="form-group form-obj" *ngIf="checkZero(feeData.cautionMoney)">
            <strong> <label for="mobileNo"> Caution Money :</label></strong> {{feeData.cautionMoney}}
        </div>
        <div class="form-group form-obj" *ngIf="checkZero(feeData.messAdvance)">
            <strong> <label for="mobileNo"> Mess Advance :</label></strong> {{feeData.messAdvance}}
        </div>
            <div class="form-group form-obj" *ngIf="checkZero(feeData.messBill)">
                <strong> <label for="mobileNo"> Mess Fees :</label></strong> {{feeData.messBill}}
            </div>
            <div class="form-group form-obj" *ngIf="checkZero(feeData.quaterFee)">
              <strong> <label for="mobileNo"> Hostel Fees :</label></strong>  {{feeData.quaterFee}}
          </div>
            <div class="form-group form-obj" *ngIf="checkZero(feeData.annualFee)" >
                <strong> <label for="mobileNo"> Annual Fees :</label></strong> {{feeData.annualFee}}
            </div>
            <div class="form-group form-obj" *ngIf="checkZero(feeData.tutionFee)">
              <strong> <label for="mobileNo"> Tution Fees:</label></strong> {{feeData.tutionFee}}
          </div>
          <div class="form-group form-obj" *ngIf="checkZero(feeData.examFee)">
            <strong> <label for="mobileNo"> Exam Fees :</label></strong> {{feeData.examFee}}
        </div>
            <div class="form-group form-obj" *ngIf="checkZero(feeData.guestCharges)">
                <strong> <label for="mobileNo"> Guest Fees :</label></strong> {{feeData.guestCharges}}
            </div>

            <div class="form-group form-obj" style="float: left;">
              <strong> <label for="mobileNo"> Total :</label></strong> {{feeData.totalCharges}}
          </div>

        </div>

        <div class="col-md-12" style="display: inline-block;">

            <div class="form-group">
                <label for="mobileNo">Mobile No.</label>
                <input type="text" formControlName="mobileNo" placeholder="Enter mobile number" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.mobileNo.errors }" />
                <div *ngIf="submitted &&f.mobileNo.errors" class="invalid-feedback">
                    <div *ngIf="f.mobileNo.errors.required">Mobile Number is required</div>
                    <div *ngIf="f.mobileNo.errors.pattern">Invalid Mobile Number</div>
                    <div *ngIf="f.mobileNo.errors.minlength && (!f.mobileNo.errors.required)">Mobile Number required of length {{f.mobileNo.errors.minlength.requiredLength}} and has length {{f.mobileNo.errors.minlength.actualLength}}  </div>
                    <div *ngIf="f.mobileNo.errors.maxlength && (!f.mobileNo.errors.required)">Mobile Number required of length {{f.mobileNo.errors.maxlength.requiredLength}} and has length {{f.mobileNo.errors.maxlength.actualLength}}  </div>
                </div>
            </div>
            <div class="form-group">
                <label for="EmailId">Email ID</label>
                <input type="text" style="text-transform: lowercase" formControlName="emailId" placeholder="Enter Email Id" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.emailId.errors }" />
                <div *ngIf="submitted &&f.emailId.errors" class="invalid-feedback">
                    <div *ngIf="f.emailId.errors.required">Email ID is required</div>
                    <div *ngIf="f.emailId.errors.pattern">Invalid Email ID</div>
                </div>
            </div>
            <div class="form-group">
                <button [disabled]="loading" style="margin-right:30px;" class="btn btn-primary" >
                    <span *ngIf="loading" class="spinner-border spinner-border-sm mr-1"></span>
                    Pay Now
                </button>
                <button (click)="redirectHome()" class="btn btn-primary" >
                  BACK TO HOME
                </button>
            </div>

        </div>


    </form>
    <div>
      <form   target="_top" #txnForm [formGroup]="tranxnForm" method="POST" action={{isgPay_url}}  >
        <input type="hidden" [value]="EncDataField"  name="EncData" formControlName="EncData">
        <input type="hidden" [value]="MerchantIdField" name="MerchantId" formControlName="MerchantId">
        <input type="hidden" [value]="BankIdField" name="BankId" formControlName="BankId">
        <input type="hidden" [value]="TerminalIdField" name="TerminalId" formControlName="TerminalId">
        <input type="hidden" [value]="VersionField" name="Version" formControlName="Version">
        <input type="hidden" [value]="TransactionId" name="OrderId" formControlName="TransactionId">
       


        </form>
      </div>
</div>
<div class="card-body" *ngIf="isRecordNotFound" >
  {{res.message}}
  <div class="errBackButtonDiv" style="width: 129px !important; margin-top: 30px;
               margin-bottom: 20px;">
                 <button style="font-size: 13px !important;" class="errBackButton" mat-raised-button (click)="redirectHome()" color="primary">BACK TO HOME</button>
  </div>
</div>
</div>
